import React from 'react';
import { TbFileSearch } from 'react-icons/tb';
import { Link } from 'react-router-dom';

import { Typography } from '@/components/atoms/Typography';
import { ClaimResponse } from '@/api/lib/claim';
import { SimpleRestaurantResponse } from '@/api/lib/restaurant';
import { findRestaurantNameById } from '@/utils/findRestaurantNameById';

export interface Props {
  isSupport?: boolean;
  claim: ClaimResponse;
  restaurantsData: SimpleRestaurantResponse[];
}

export const ClaimHomePageItem: React.FC<Props> = ({ isSupport, claim, restaurantsData }: Props) => {
  const linkRoute =
    isSupport && claim.status === 'PENDING'
      ? `/claim-moderation/${claim.id}`
      : claim.status === 'APPROVED'
        ? '/claim?info=alreadyClaimed'
        : '/claim?info=requestReceived';

  return (
    <Link
      to={linkRoute}
      className="border-primary bg-yellow-50 border-dashed hover:cursor-pointer text-center w-full flex-col flex gap-2 hover:text-black hover:border-primary duration-200 md:w-52 justify-center ease-in-out p-2 border rounded-lg hover:bg-gray-100 items-center text-black"
    >
      <div className="flex gap-3 font-semibold">{findRestaurantNameById(claim.restaurantId, restaurantsData)}</div>

      <div className="flex gap-2 items-center">
        <TbFileSearch className="text-primary min-w-5 min-h-5 ring-primary" />
        <Typography variant="extraSmall" color="primary">
          En cours d'analyse
        </Typography>
      </div>
    </Link>
  );
};
